import type React from "react";
/**
 * A fixed-position menu's anchor, in viewport coordinates. `top` opens the menu
 * downward from the anchor; `bottom` opens it upward, which is what an anchor in
 * the lower half of the viewport gets: a menu fixed below a row near the bottom
 * of the window ran off-screen, and a fixed element cannot be scrolled into view
 * (the checkpoint-run e2e: "Inspect" below the fold, unclickable).
 */
export type MenuAnchor = { right: number } & ({ top: number } | { bottom: number });

export function anchorFor(
  r: { top: number; bottom: number },
  right: number,
  gap: number,
  viewportHeight: number = window.innerHeight,
): MenuAnchor {
  if (r.bottom > viewportHeight / 2) {
    return { bottom: Math.max(0, viewportHeight - r.top + gap), right };
  }
  return { top: r.bottom + gap, right };
}

export function anchorStyle(a: MenuAnchor): React.CSSProperties {
  return "top" in a ? { top: a.top, right: a.right } : { bottom: a.bottom, right: a.right };
}

